export default {

    // AGENT AUTHENTICATION

    AGENT_LOGIN_WITH_CREDS: {
        url: "/api/v1/agent/authentication/credential/login",
        method: "post",
    },

    AGENT_PASSWORD_RESET: {
        url: "/api/v1/agent/authentication/credential/change",
        method: "put",
    },

    AGENT_LOGIN_REQUEST_VIA_OTP: {
        url: "/api/v1/agent/authentication/otp/request",
        method: "post",
    },

    AGENT_LOGIN_VERIFY_VIA_OTP: {
        url: "/api/v1/agent/authentication/otp/verify",
        method: "put",
    },

    AGENT_GENERATE_TEMPORARY_PASSWORD: {
        url: "/api/v1/agent/authentication/reset/{email_address}",
        method: "put"
    },

    GET_AGENT_DETAILS: {
        url: "/api/v1/agent/authentication/details",
        method: "get",
    },

    // AGENT
    ADD_AGENT: {
        url: "/api/v1/agent",
        method: "post",
    },
    GET_AGENTS: {
        url: "/api/v1/agent",
        method: "get",
    },
    GET_AGENT_BY_ID: {
        url: "/api/v1/agent/{agent_id}",
        method: "get",
    },
    UPDATE_AGENT: {
        url: "/api/v1/agent/{agent_id}",
        method: "put",
    },
    DELETE_AGENT: {
        url: "/api/v1/agent/{agent_id}",
        method: "delete",
    },

    // AGENT APPLICATIONS
    ADD_AGENT_APPLICATION: {
        url: "/api/v1/agent-application",
        method: "post",
    },
    GET_AGENT_APPLICATIONS: {
        url: "/api/v1/agent-application",
        method: "get",
    },
    GET_AGENT_APPLICATION_BY_ID: {
        url: "/api/v1/agent-application/{agent_application_id}",
        method: "get",
    },
    UPDATE_AGENT_APPLICATION: {
        url: "/api/v1/agent-application/{agent_application_id}",
        method: "put",
    },
    DELETE_AGENT_APPLICATION: {
        url: "/api/v1/agent-application/{agent_application_id}",
        method: "delete",
    },
}